/*undefined*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.Access = (function() {

    /**
     * Namespace Access.
     * @exports Access
     * @namespace
     */
    var Access = {};

    Access.LicenseDataModel = (function() {

        /**
         * Properties of a LicenseDataModel.
         * @memberof Access
         * @interface ILicenseDataModel
         * @property {string|null} [expiryDate] LicenseDataModel expiryDate
         * @property {boolean|null} [isExpired] LicenseDataModel isExpired
         * @property {boolean|null} [isExpiring] LicenseDataModel isExpiring
         * @property {boolean|null} [isGracePeriod] LicenseDataModel isGracePeriod
         * @property {number|null} [gracePeriod] LicenseDataModel gracePeriod
         */

        /**
         * Constructs a new LicenseDataModel.
         * @memberof Access
         * @classdesc Represents a LicenseDataModel.
         * @implements ILicenseDataModel
         * @constructor
         * @param {Access.ILicenseDataModel=} [p] Properties to set
         */
        function LicenseDataModel(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * LicenseDataModel expiryDate.
         * @member {string|null|undefined} expiryDate
         * @memberof Access.LicenseDataModel
         * @instance
         */
        LicenseDataModel.prototype.expiryDate = null;

        /**
         * LicenseDataModel isExpired.
         * @member {boolean|null|undefined} isExpired
         * @memberof Access.LicenseDataModel
         * @instance
         */
        LicenseDataModel.prototype.isExpired = null;

        /**
         * LicenseDataModel isExpiring.
         * @member {boolean|null|undefined} isExpiring
         * @memberof Access.LicenseDataModel
         * @instance
         */
        LicenseDataModel.prototype.isExpiring = null;

        /**
         * LicenseDataModel isGracePeriod.
         * @member {boolean|null|undefined} isGracePeriod
         * @memberof Access.LicenseDataModel
         * @instance
         */
        LicenseDataModel.prototype.isGracePeriod = null;

        /**
         * LicenseDataModel gracePeriod.
         * @member {number|null|undefined} gracePeriod
         * @memberof Access.LicenseDataModel
         * @instance
         */
        LicenseDataModel.prototype.gracePeriod = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * LicenseDataModel _expiryDate.
         * @member {"expiryDate"|undefined} _expiryDate
         * @memberof Access.LicenseDataModel
         * @instance
         */
        Object.defineProperty(LicenseDataModel.prototype, "_expiryDate", {
            get: $util.oneOfGetter($oneOfFields = ["expiryDate"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * LicenseDataModel _isExpired.
         * @member {"isExpired"|undefined} _isExpired
         * @memberof Access.LicenseDataModel
         * @instance
         */
        Object.defineProperty(LicenseDataModel.prototype, "_isExpired", {
            get: $util.oneOfGetter($oneOfFields = ["isExpired"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * LicenseDataModel _isExpiring.
         * @member {"isExpiring"|undefined} _isExpiring
         * @memberof Access.LicenseDataModel
         * @instance
         */
        Object.defineProperty(LicenseDataModel.prototype, "_isExpiring", {
            get: $util.oneOfGetter($oneOfFields = ["isExpiring"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * LicenseDataModel _isGracePeriod.
         * @member {"isGracePeriod"|undefined} _isGracePeriod
         * @memberof Access.LicenseDataModel
         * @instance
         */
        Object.defineProperty(LicenseDataModel.prototype, "_isGracePeriod", {
            get: $util.oneOfGetter($oneOfFields = ["isGracePeriod"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * LicenseDataModel _gracePeriod.
         * @member {"gracePeriod"|undefined} _gracePeriod
         * @memberof Access.LicenseDataModel
         * @instance
         */
        Object.defineProperty(LicenseDataModel.prototype, "_gracePeriod", {
            get: $util.oneOfGetter($oneOfFields = ["gracePeriod"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Encodes the specified LicenseDataModel message. Does not implicitly {@link Access.LicenseDataModel.verify|verify} messages.
         * @function encode
         * @memberof Access.LicenseDataModel
         * @static
         * @param {Access.ILicenseDataModel} m LicenseDataModel message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LicenseDataModel.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.expiryDate != null && Object.hasOwnProperty.call(m, "expiryDate"))
                w.uint32(10).string(m.expiryDate);
            if (m.isExpired != null && Object.hasOwnProperty.call(m, "isExpired"))
                w.uint32(16).bool(m.isExpired);
            if (m.isExpiring != null && Object.hasOwnProperty.call(m, "isExpiring"))
                w.uint32(24).bool(m.isExpiring);
            if (m.isGracePeriod != null && Object.hasOwnProperty.call(m, "isGracePeriod"))
                w.uint32(32).bool(m.isGracePeriod);
            if (m.gracePeriod != null && Object.hasOwnProperty.call(m, "gracePeriod"))
                w.uint32(40).int32(m.gracePeriod);
            return w;
        };

        /**
         * Encodes the specified LicenseDataModel message, length delimited. Does not implicitly {@link Access.LicenseDataModel.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Access.LicenseDataModel
         * @static
         * @param {Access.ILicenseDataModel} message LicenseDataModel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LicenseDataModel.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a LicenseDataModel message from the specified reader or buffer.
         * @function decode
         * @memberof Access.LicenseDataModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {Access.LicenseDataModel} LicenseDataModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LicenseDataModel.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.Access.LicenseDataModel();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.expiryDate = r.string();
                    break;
                case 2:
                    m.isExpired = r.bool();
                    break;
                case 3:
                    m.isExpiring = r.bool();
                    break;
                case 4:
                    m.isGracePeriod = r.bool();
                    break;
                case 5:
                    m.gracePeriod = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Decodes a LicenseDataModel message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Access.LicenseDataModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Access.LicenseDataModel} LicenseDataModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LicenseDataModel.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        return LicenseDataModel;
    })();

    return Access;
})();

module.exports = $root;
